

























































































































import Vue from "vue";
import { Component, Emit, Prop, Watch } from "vue-property-decorator";
import { post } from "../../services/webclient/webclient";
import "./popups.less";
import { translate } from "../../services/translation/translation";

declare let grecaptcha;

@Component
export default class RegisterPopup extends Vue {
  @Prop() targetGroups: any;
  target_group_id: string = "";
  email: string = "";
  password: string = "";
  first_name: string = "";
  last_name: string = "";
  isVisible = false;
  backendMessage = "";
  customErrors = [];
  attachedRecaptcha = false;
  testVariable: string = 'alma';

  constructor() {
    super();
  }

  mounted() {
    let self = this;
    $(document).on("click toochstart", ".calc-reg", function() {
      self.isVisible = true;
    });
    grecaptcha.render("reg-recaptcha", {
      sitekey: "6Lcbfk0UAAAAAIP7DZbkxEAbVhqPjLzSwkX4QsFl",
      callback: function(data) {
        self.grecaptchaFin(data);
      }
    });
  }

  grecaptchaFin(data) {
    this.$validator.validate("g-recaptcha-response", data);
  }

  trans(key) {
    return translate(key);
  }

  showError(fieldName: string): boolean {
    return (
      this.fields[fieldName] &&
      this.fields[fieldName].touched &&
      this.errors.has(fieldName)
    );
  }

  get customErrorsText() {
    return this.customErrors.join("<br>");
  }

  register() {
    let self = this;
    //grecaptcha.execute();
    //kell még google recaptcha ellenőrzés is
    if (!this.attachedRecaptcha) {
      this.attachedRecaptcha = true;
      (this as any).$validator.attach({
        name: "g-recaptcha-response",
        rules: "required"
      });
    }

    self.customErrors = [];
    if (self.validateAll()) {
      post("/postRegistration", {
        email: this.email,
        password: this.password,
        target_group_id: this.target_group_id.length>0 ? this.target_group_id : this.targetGroups[0].id.toString(),
        first_name: this.first_name,
        last_name: this.last_name,
        "g-recaptcha-response": $('[name="g-recaptcha-response"]').val()
      }).then(
        res => {
          console.log(res);
          if (res.hasOwnProperty("redirectURL")) {
            self.registered(true);
            self.isVisible = false;
          } else {
            self.registered(false);
            grecaptcha.reset();
          }
        },
        res => {
          if (res.status == 422) {
            grecaptcha.reset();
            for (let prop in res.responseJSON.errors) {
              (self.customErrors as any).push(res.responseJSON.errors[prop][0]);
            }
          }
        }
      );
    }

    return false;
    //callbackben kezelni kellene hogy a sikeres vagy a sikertelen jelenjen meg
  }

  setDirty() {
    for (let f in (this as any).fields) {
      (this as any).$validator.flag(f, { untouched: false });
    }
  }

  validateAll() {
    this.setDirty();
    return (this as any).$validator.validateAll();
  }

  close(ok) {
    this.isVisible = false;
  }


  @Emit("registered")
  registered(status) {}
}
